(() => {
  'use strict';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const carousels = new Map();
  function initCarousel(root) {
    if (carousels.has(root)) return;
    const track = root.querySelector('.br-carousel-track');
    const slides = Array.from(root.querySelectorAll('.br-carousel-slide'));
    if (!track || !slides.length) return;
    const dots = root.querySelector('[data-br-dots]');
    const pause = root.querySelector('[data-br-pause]');
    const previous = root.querySelector('[data-br-prev]');
    const next = root.querySelector('[data-br-next]');
    const controller = new AbortController();
    const options = { signal: controller.signal };
    let timer, paused = reducedMotion.matches, hovering = false, focusing = false;
    const max = () => Math.max(0, track.scrollWidth - track.clientWidth);
    const positions = () => Array.from(new Set(slides.map(slide => Math.min(slide.offsetLeft - slides[0].offsetLeft, max()))));
    const current = () => positions().reduce((best, pos, i, all) => Math.abs(pos - track.scrollLeft) < Math.abs(all[best] - track.scrollLeft) ? i : best, 0);
    const go = index => {
      const list = positions();
      const chosen = (index + list.length) % list.length;
      track.scrollTo({ left: list[chosen], behavior: reducedMotion.matches ? 'instant' : 'smooth' });
    };
    const sync = () => {
      if (!dots) return;
      const list = positions();
      if (dots.children.length !== list.length) {
        dots.replaceChildren();
        list.forEach((_, index) => {
          const dot = document.createElement('button');
          dot.type = 'button'; dot.className = 'br-dot';
          dot.setAttribute('aria-label', `Position ${index + 1}`);
          dot.addEventListener('click', () => { go(index); restart(); }, options);
          dots.append(dot);
        });
      }
      Array.from(dots.children).forEach((dot, i) => dot.setAttribute('aria-current', i === current() ? 'true' : 'false'));
      if (previous) previous.disabled = max() < 2;
      if (next) next.disabled = max() < 2;
    };
    function stop() { window.clearInterval(timer); }
    function restart() {
      stop();
      if (root.dataset.autoplay !== 'true' || paused || hovering || focusing || document.hidden || reducedMotion.matches || max() < 2) return;
      timer = window.setInterval(() => go(current() + 1), Math.max(3000, Number(root.dataset.delay) || 6000));
    }
    const updatePause = () => {
      if (!pause) return;
      pause.setAttribute('aria-pressed', String(paused));
      pause.setAttribute('aria-label', paused ? 'Reprendre le défilement' : 'Mettre le défilement en pause');
      pause.textContent = paused ? '▶' : 'Ⅱ';
    };
    if (previous) previous.addEventListener('click', () => { go(current() - 1); restart(); }, options);
    if (next) next.addEventListener('click', () => { go(current() + 1); restart(); }, options);
    if (pause) pause.addEventListener('click', () => { paused = !paused; updatePause(); restart(); }, options);
    track.addEventListener('scroll', sync, { passive: true, signal: controller.signal });
    track.addEventListener('keydown', event => {
      if (event.target !== track) return;
      if (event.key === 'ArrowRight') { event.preventDefault(); go(current() + 1); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); go(current() - 1); }
    }, options);
    root.addEventListener('mouseenter', () => { hovering = true; stop(); }, options);
    root.addEventListener('mouseleave', () => { hovering = false; restart(); }, options);
    root.addEventListener('focusin', () => { focusing = true; stop(); }, options);
    root.addEventListener('focusout', () => { window.setTimeout(() => { focusing = root.contains(document.activeElement); restart(); }, 0); }, options);
    document.addEventListener('visibilitychange', restart, options);
    reducedMotion.addEventListener('change', () => { paused = reducedMotion.matches; updatePause(); restart(); }, options);
    const observer = new ResizeObserver(() => { sync(); restart(); }); observer.observe(track);
    updatePause(); sync(); restart();
    carousels.set(root, () => { stop(); observer.disconnect(); controller.abort(); carousels.delete(root); });
  }
  function init(scope = document) {
    scope.querySelectorAll('[data-br-carousel]').forEach(initCarousel);
    const formDetails = document.querySelector('[data-br-devis]');
    if (formDetails && (location.hash === '#devis' || formDetails.querySelector('.br-form-message'))) formDetails.open = true;
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]'); if (!link) return;
    let url; try { url = new URL(link.href, location.href); } catch (_) { return; }
    if (url.origin !== location.origin || url.pathname !== location.pathname) return;
    if (url.hash === '#devis') {
      const details = document.querySelector('[data-br-devis]');
      if (details) details.open = true;
    }
    if (link.closest('[data-br-menu]')) link.closest('[data-br-menu]').open = false;
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-br-menu][open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); });
  });
  window.addEventListener('hashchange', () => {
    if (location.hash === '#devis') { const details = document.querySelector('[data-br-devis]'); if (details) details.open = true; }
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-br-carousel]').forEach(root => { const destroy = carousels.get(root); if (destroy) destroy(); }));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true }); else init();
})();
